if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      // }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();

      //   // ✅ Pincode validation
      //   const pdpPincodeInput = document.querySelector(".pincode-check-wrapper .pop_upPincode");
      //   const expressShippingResponse = document.querySelector("#express_shipping_response");
      //   // if (expressShippingResponse) expressShippingResponse.innerHTML = ''; // Clear old error

      //   if (!pdpPincodeInput || !pdpPincodeInput.value.trim()) {
      //     if (expressShippingResponse) {
      //       expressShippingResponse.innerHTML = '<p class="error">Please enter Pincode first</p>';
      //       expressShippingResponse.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //     }
      //     return;
      //   }

      //   const pincode = pdpPincodeInput.value.trim();
      //   if (!/^[1-9][0-9]{5}$/.test(pincode)) {
      //     if (expressShippingResponse) {
      //       expressShippingResponse.innerHTML = '<p class="error">Please enter a valid 6-digit pincode</p>';
      //       expressShippingResponse.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //     }
      //     return;
      //   }

      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();
      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure("add:paint-updated-sections", () => {
      //                 this.cart.renderContents(response);
      //               });
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure("add:paint-updated-sections", () => {
      //           this.cart.renderContents(response);
      //         });
      //       }

      //       // ✅ Show success animation
      //       document.querySelector('.pdp_cartBtn')?.classList.remove('hidden');
      //       document.querySelector('.prd-addedCart')?.classList.add('active');
      //       this.classList.add('hidden');
      //       setTimeout(() => {
      //         document.querySelector('.pdp_cartBtn')?.classList.add('hidden');
      //       this.classList.remove('hidden');
      //       }, 3000);
      //       setTimeout(() => {
      //         document.querySelector('.prd-addedCart')?.classList.remove('active');
      //       }, 1500);
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');
      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }

        // ✅ Listen for variant changes
        this.form.addEventListener('change', this.onVariantChange.bind(this));

        // ✅ Initial check on load
        this.checkVariantPrice();
      }

      // ✅ New method: Check if variant price is 0
      checkVariantPrice() {
        const selectedVariant = this.getSelectedVariant();
        if (!selectedVariant) return;

        if (selectedVariant.price <= 0) {
          this.toggleSubmitButton(true, 'Not Available');
        } else {
          this.toggleSubmitButton(false);
        }
      }

      // ✅ Get the currently selected variant from Shopify's JSON
      getSelectedVariant() {
        try {
          const variantsData = JSON.parse(document.querySelector('[data-product-json]').textContent);
          const variantId = this.variantIdInput.value;
          return variantsData.variants.find(v => v.id == variantId);
        } catch (e) {
          console.error('Could not fetch variant data:', e);
          return null;
        }
      }

      // ✅ Trigger price check on variant change
      onVariantChange() {
        this.checkVariantPrice();
      }
      onSubmitHandler(evt) {
  evt.preventDefault();

  const pdpPincodeInput = document.querySelector(".pincode-check-wrapper .pop_upPincode");
  const expressShippingResponse = document.querySelector("#express_shipping_response");

  // ✅ SessionStorage Pincode Check First
  const storedPincode = sessionStorage.getItem("storage_pincode");
  // ✅ Check live input pincode if available (to update or override stored one)
  if (!pdpPincodeInput || !pdpPincodeInput.value.trim()) {
    if (expressShippingResponse) {
      expressShippingResponse.innerHTML = '<p class="error">Please enter Pincode first</p>';
      expressShippingResponse.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }
  if (!storedPincode || !/^[1-9][0-9]{5}$/.test(storedPincode)) {
    if (expressShippingResponse) {
      expressShippingResponse.innerHTML = '<p class="error">Please check pincode serviceability</p>';
      expressShippingResponse.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }


  const pincode = pdpPincodeInput.value.trim();
  if (!/^[1-9][0-9]{5}$/.test(pincode)) {
    if (expressShippingResponse) {
      expressShippingResponse.innerHTML = '<p class="error">Please enter a valid 6-digit pincode</p>';
      expressShippingResponse.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  // ✅ Save latest valid pincode to sessionStorage
  sessionStorage.setItem("storage_pincode", pincode);

  // Proceed with form submission
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });

      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
          });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        CartPerformance.measure("add:paint-updated-sections", () => {
          this.cart.renderContents(response);
        });
      }

      // ✅ Show success animation
      document.querySelector('.pdp_cartBtn')?.classList.remove('hidden');
      document.querySelector('.prd-addedCart')?.classList.add('active');
      this.classList.add('hidden');
      setTimeout(() => {
        document.querySelector('.prd-addedCart')?.classList.remove('active');
      }, 1500);
      setTimeout(() => {
        document.querySelector('.pdp_cartBtn')?.classList.add('hidden');
        this.classList.remove('hidden');
      }, 5000);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        // if (errorMessage) this.errorMessage.textContent = errorMessage;
        const variantErrorMessage = document.querySelector('.product-variant__error-message');
        if (errorMessage) {
           // $(".product-form__input.product-form__input--pill").addClass("size-button");
          if (errorMessage === "Required parameter missing or invalid: id") {
            variantErrorMessage.textContent = " Please select a size";
          } else {
            variantErrorMessage.textContent = errorMessage;
          }
          const variantSelectsElement = document.querySelector('variant-selects');
          if (variantErrorMessage) {
            variantErrorMessage.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
          if (this.errorMessage) {
            this.errorMessage.classList.add('new-error-class');
        }
          // setTimeout(function() {
          //   variantErrorMessage.textContent = ""
          // }, 4000);
        }    
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
